<app-header></app-header>
<main id="content">
  <section id="path-page">
    <section [attr.data-status]="eachPathObj.status.status ?eachPathObj.status.status:''" class="path-info">
      <div [ngStyle]="{'background': '#464646 url(' + eachPathObj.image + ')'}" class="hero hero-path"></div>
      <div class="container flex-row end">
        <div class="row">
          <div class="col-md-8">
            <ul class="breadcrumbs inline-block">
              <li *ngIf="myPaths">
                <a href="/#/my-paths" class="link">My Paths </a>
              </li>
              <li *ngIf="!myPaths">
                  <a href="/#/explore-paths" class="link">Explore Paths </a>
                </li>
            </ul>
            <div class="group">
              <h1 class="heading-lg">{{eachPathObj.name}}</h1>
              <span class="label" *ngIf="eachPathObj.status.status == 'active'">my current path</span>
            </div>
            <ul class="flex-row social-panel">
              <li class="col">
                <a href="/#/not-yet-enabled" class="like-btn">
                  <i class="icon-wb stroke heart"></i>
                  <span class="count"></span>
                  <span class="title">Like</span>
                </a>
              </li>
              <li class="col">
                <a href="/#/not-yet-enabled">
                  <i class="icon-wb stroke J8"></i>
                  <span class="count"></span>
                  <span class="title">Share on your wall</span>
                </a>
              </li>
              <li class="col">
                <a href="/#/not-yet-enabled">
                  <i class="icon-wb stroke C15"></i>
                  <span class="count"></span>
                  <span class="title">Leave an impression</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-md-4 sticked">
            <div class="status-box flex-row end center" *ngIf="eachPathObj.status.status == 'abandoned' || eachPathObj.status.status == undefined">
              <div class="img-wrap">
                <img src="/assets/images/doctor.svg" alt="">
              </div>
              <p class="text text-md text-center">This path is available for you !</p>
              <a role="button" (click)="updateMyPath()" class="btn btn-block btn-md btn-primary">Take this Path</a>
            </div>
            <div class="status-box flex-row middle center" *ngIf="eachPathObj.status.status == 'completed'">
              <div class="block text-center">
                <i class="fa fa-check"></i>
                <p class="text text-md">
                  You've already completed this path.
                  <br>But you can do any of the exercises again.
                </p>
              </div>
            </div>
            <div class="status-box hide showSvg">
              <div class="progress-circle" data-circle-type="percentage">
                <div class="wrap" id="svgPath">
                  <p>
                    <span>{{eachPathObj.status.exercises_completed_percentage}}%</span>
                    <span>complete</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section [attr.data-status]="eachPathObj.status.status" class="path-description">
      <div class="container">
        <div class="row">
          <div class="col-md-10">
            <p class="text text-xl">{{eachPathObj.description}}</p>
          </div>
        </div>
      </div>
    </section>
    <section [attr.data-status]="eachPathObj.status.status" class="path-exercises">
      <div class="container-fluid">
        <div class="row next-exercise" *ngIf="eachPathObj.status.status != 'completed' && activeExercisesObj">
          <div class="col-md-12">
            <div class="container">
              <div class="row flex-row middle">
                <div class="col-md-4 full-width-mobile">
                  <div class="icon-container">
                    <i class="fa fa-arrow-right"></i>
                    <span>{{activeExercisesObj.sequence}} Exercise</span>
                  </div>
                  <div class="img-container">
                    <img src="{{activeExercisesObj.image}}">
                  </div>
                </div>
                <div class="col-md-8 no-padding">
                  <a href="/#/exercise/{{activeExercisesObj.id}}" [attr.data-status]="eachPathObj.status.status" class="link block">
                    <h3 class="heading heading-sm heading-underline">{{activeExercisesObj.name}}</h3>
                  </a>
                  <p class="text text-md">{{ (activeExercisesObj.description.length>200) ? (activeExercisesObj.description | slice:0:200)+'...' : (activeExercisesObj.description)}}
                    <a href="/#/exercise/{{activeExercisesObj.id}}" data-action="expandText">more</a>
                  </p>
                  <div class="group">
                    <a href="/#/exercise/current/ongoing" role="button" class="btn btn-inline btn-lg btn-primary" *ngIf="myPaths && eachPathObj.status.status != 'abandoned'">Do your NEXT EXERCISE</a>
                    <a href="/#/exercise/{{activeExercisesObj.id}}" class="link link-inline link-primary text-sm text-uppercase">Show exercise details
                      <i class="icon-wb stroke W20"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row locked-exercises" *ngIf="lockedExerciseObj.length > 0">
          <div class="col-md-12">
            <div class="container">
              <div class="row">
                <div class="col-md-9 col-md-offset-3">
                  <h2 class="heading-sm heading-underline orange">What comes next</h2>
                </div>
              </div>
              <div class="row exercise" *ngFor="let locked of lockedExerciseObj">
                <div class="col-md-1 col-md-offset-2 text-right">
                  <div class="icon-container">
                    <i class="fa fa-lock"></i>
                    <span>{{locked.sequence}}</span>
                  </div>
                </div>
                <div class="col-md-9">
                  <a href="/#/exercise/{{locked.id}}" class="link block">
                    <h3 class="heading heading-sm heading-underline">{{locked.name}}</h3>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row completed-exercises" *ngIf="completedExercisesObj.length > 0">
          <div class="col-md-12">
            <div class="container">
              <div class="row">
                <div class="col-md-9 col-md-offset-3">
                  <h2 class="heading-sm heading-underline orange">Completed exercises</h2>
                </div>
              </div>
              <div class="row exercise" *ngFor="let completed of completedExercisesObj">
                <div class="col-md-1 col-md-offset-2 text-right">
                  <div class="icon-container">
                    <i class="fa fa-check"></i>
                    <span>{{completed.sequence}}</span>
                  </div>
                </div>
                <div class="col-md-9">
                  <a href="/#/exercise/{{completed.id}}" class="link block">
                    <h3 class="heading heading-sm heading-underline">{{completed.name}}</h3>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</main>
<app-dailyquotes></app-dailyquotes>
<app-footer></app-footer>
<app-menu></app-menu>


<div class="modal fade" id="takeMyPathModal">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content">
        <img src="/assets/images/doctor.svg" alt="">
        <h1 class="heading-lg text-center">You`re now taking this path !</h1>
        <p class="text text-xl text-center">Awesome, the path "{{eachPathObj.name}}" has been added in "My Path" and you can start doing its exercises right
          away !</p>
        <button (click)="goToFirstExercise()" class="btn btn-block btn-md btn-primary">Take me to the first exercise</button>
        <button data-dismiss="modal" class="btn btn-block btn-lg">Not Now</button>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/eachpath/eachpath.component.html